<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'Mantenimiento de Dotación por Empleado'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="formulario" novalidate class="form-group">
          <div class="row">
            <div [class]="'col-md-8'">
              <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('cedula')"
                [placeholder]="'Cédula'" formControlName="cedula" [label]="'Cédula*'" [type]="'number'" [id]="'cedula'">
              </app-lfsa-input>
            </div>
            <div [class]="'col-md-4'">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" (click)="buscarInfoEmpleado()">Buscar</button>
            </div>
            <div [class]="'col-md-6'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('depart')"
                [placeholder]="'Ninguno'" formControlName="depart" [label]="'Departamento'" [type]="'text'" [id]="'depart'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>
            <div [class]="'col-md-6'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('ccosto')"
                [placeholder]="'Ninguno'" formControlName="ccosto" [label]="'Centro de Costo'" [type]="'text'" [id]="'ccosto'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>
            <div [class]="'col-md-6'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('filial')"
                [placeholder]="'Ninguno'" formControlName="filial" [label]="'Filial'" [type]="'text'" [id]="'filial'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>
            <div [class]="'col-md-6'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('predaXentregar')"
                [placeholder]="'Total de prendas por entregar'" formControlName="predaXentregar" [label]="'Total de prendas por entregar'" [type]="'text'" [id]="'predaXentregar'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>
            <div [class]="'col-md-12'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('fullname')"
                [placeholder]="'Apellidos y Nombres'" formControlName="fullname" [label]="'Apellidos y Nombres'" [type]="'text'" [id]="'fullname'" [isReadOnly]="true">
              </app-lfsa-input>
            </div>
          </div>
        </form>
        <!-- GRID DE CONTROL DE PRENDAS -->
        <div class="row">
          <div class="col-md-6">
            <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
            <div *ngIf="!loading">
              <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
                No existen datos para la lista de Prendas.
              </div>
              <div *ngIf="!listaVacia">
                <div class="row">
                  <div [class]="'col-md-12'">
                    <label><b>Prendas por Entregar</b></label>
                  </div>
                </div>
                <div class="row">
                  <div [class]="'col-md-12'">
                    <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
                      (keyup)="onQuickFilterChanged()" #quickFilter />
                  </div>
                </div>
                <div [class]="'col-md-12'">
                  <ag-grid-angular #agGrid class=" {{clothesModulo.agGrid.class}}" [ngStyle]="clothesModulo.agGrid.style"
                    id="{{clothesModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs"
                    [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
                    >
                  </ag-grid-angular>
                </div>
              </div>
            </div>
          </div>
          <!-- PRENDA A ENTREGAR -->
          <div class="col-md-6">
            <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
            <div *ngIf="!loading">
              <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
                No existen datos para la lista de Prendas.
              </div>
              <div *ngIf="!listaVacia">
                <div class="row">
                  <div [class]="'col-md-12'">
                    <label><b>Prendas por Empleado</b></label>
                  </div>
                </div>
                <div class="row">
                  <div [class]="'col-md-12'">
                    <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarEntrega" id="quickFilterEntrega "
                      (keyup)="onQuickFilterChangedEntrega()" #quickFilter />
                  </div>
                </div>
                <div [class]="'col-md-12'">
                  <ag-grid-angular #agGrid class=" {{clothesModulo.agGrid.class}}" [ngStyle]="clothesModulo.agGrid.style"
                    id="{{clothesModulo.agGrid.id}}" [frameworkComponents]="frameworkComponentsEntrega " [columnDefs]="columnDefsEntrega"
                    [rowSelection]="rowSelectionEntrega" [rowData]="rowDataEntrega" (gridReady)="onGridReadyEntrega($event)" [pagination]="true"
                     (cellClicked)="callModalCantidadTipo($event)">
                  </ag-grid-angular>
                </div>
              </div>
            </div>
          </div>
          <!-- BOTONES DE ACCION -->
          <div [class]="'col-md-3'">
            <label>&nbsp;</label><br>
            <button class="btn btn-success btn-block" (click)="saveDriverClothes()">Guardar</button>
          </div>
          <div [class]="'col-md-3'">
            <label>&nbsp;</label><br>
            <button class="btn btn-info btn-block" (click)="callModalHistory()">Historial de Entregas</button>
          </div>
          <div [class]="'col-md-3'">
            <label>&nbsp;</label><br>
            <button class="btn btn-warning btn-block" (click)="printActaEntrega()">Acta de Entrega</button>
          </div>
          <div [class]="'col-md-3'">
            <label>&nbsp;</label><br>
            <button class="btn btn-secondary btn-block" (click)="callReportWindows()">Reportes</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<br>

<!-- MODAL TALLA PRENDA -->
<app-lfsa-modal [innTemplate]="enviarModalTalla" [titulo]="'Seleccionar Talla de Prenda'" [idButton]="'abrirModalTalla'" [idOpen]="'ModalTalla'"
  [idClose]="'cerrarModalTalla'"></app-lfsa-modal>
<ng-template #enviarModalTalla>
  <form [formGroup]="formularioTalla" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formularioTalla.get('codbaan')"
          [placeholder]="'Codigó BAAN'" formControlName="codbaan" [label]="'Codigó BAAN'" [type]="'text'" [id]="'codbaan'" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formularioTalla.get('descrp')"
          [placeholder]="'Descripción'" formControlName="descrp" [label]="'Ingrese Descripción'" [type]="'text'" [id]="'descrp'" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbOpcionesTalla" 
          formControlName="size" [control]="formularioTalla.get('size')" [claseLabel]="'letrasDanger'" [label]="'Seleccione Talla*'" [id]="'size'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioTalla.invalid"
            (click)="addElementToClothesDeliver()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- MODAL CANTIDAD Y TIPO DELIVER -->
<app-lfsa-modal [innTemplate]="enviarModalCantidad" [titulo]="'Seleccionar Cantidad y Tipo de Movimiento'" [idButton]="'abrirModalCantidadTipo'" [idOpen]="'ModalCantidadTipo'"
  [idClose]="'cerrarModalCantidadTipo'"></app-lfsa-modal>
<ng-template #enviarModalCantidad>
  <form [formGroup]="formularioCantTipo" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formularioCantTipo.get('codbaan')"
          [placeholder]="'Codigó BAAN'" formControlName="codbaan" [label]="'Codigó BAAN'" [type]="'text'" [id]="'codbaan'" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formularioCantTipo.get('descrp')"
          [placeholder]="'Descripción'" formControlName="descrp" [label]="'Ingrese Descripción'" [type]="'text'" [id]="'descrp'" [isReadOnly]="true">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]="" [control]="formularioCantTipo.get('cant')"
          [placeholder]="'Cantidad'" formControlName="cant" [label]="'Ingrese Cantidad*'" [type]="'number'" [id]="'cant'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbTipoDeliver" 
          formControlName="tipo" [control]="formularioCantTipo.get('tipo')" [claseLabel]="'letrasDanger'" [label]="'Seleccione Tipo*'" [id]="'tipo'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioCantTipo.invalid"
            (click)="setDeliverClothes()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- MODAL HISTORY DELIVER -->
<app-lfsa-modal [innTemplate]="enviarModalHistory" [titulo]="'Historial de Entrega'" [idButton]="'abrirModalHistory'" 
[idOpen]="'ModalHistory'" [idClose]="'cerrarModalHistory'"></app-lfsa-modal>
<ng-template #enviarModalHistory>
  <div class="row">
    <div [class]="'col-md-5'">
      <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
      <div *ngIf="!loading">
        <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVaciaHistory">
          No existen datos para la lista de Prendas.
        </div>
        <div *ngIf="!listaVaciaHistory">
          <div class="row">
            <div [class]="'col-md-12'">
              <label><b>Historial de Entrega</b></label>
            </div>
          </div>
          <div class="row">
            <div [class]="'col-md-12'">
              <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarHistory" id="quickFilterHistory"
                (keyup)="onQuickFilterChangedHistory()" #quickFilter />
            </div>
          </div>
          <div [class]="'col-md-12'">
            <ag-grid-angular #agGrid class=" {{clothesModulo.agGrid.class}}"  [ngStyle]="clothesModulo.agGrid.style"
              id="{{clothesModulo.agGrid.id}}" [frameworkComponents]="frameworkComponentsHistory " [columnDefs]="columnDefsHistory"
              [rowSelection]="rowSelectionHistory" [rowData]="rowDataHistory" (gridReady)="onGridReadyHistory($event)" [pagination]="true"
               (cellClicked)="setListDetailEntrega($event)">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>

    <div [class]="'col-md-7'">
      <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
      <div *ngIf="!loading">
        <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVaciaHistory">
          No existen datos para la lista de Detalle de Entrega.
        </div>
        <div *ngIf="!listaVaciaHistory">
          <div class="row">
            <div [class]="'col-md-12'">
              <label><b>Detalle de Entrega</b></label>
            </div>
          </div>
          <div class="row">
            <div [class]="'col-md-12'">
              <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarDetail" id="quickFilterDetail"
                (keyup)="onQuickFilterChangedDetail()" #quickFilter />
            </div>
          </div>
          <div [class]="'col-md-12'">
            <ag-grid-angular #agGrid class=" {{clothesModulo.agGrid.class}}"  [ngStyle]="clothesModulo.agGrid.style"
              id="{{clothesModulo.agGrid.id}}" [frameworkComponents]="frameworkComponentsDetail " [columnDefs]="columnDefsDetail"
              [rowSelection]="rowSelectionDetail" [rowData]="rowDataDetail" (gridReady)="onGridReadyDetail($event)" [pagination]="true"
              >
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
    <div [class]="'col-md-12'">
      <label>&nbsp;</label><br>
      <button class="btn btn-warning btn-block" (click)="viewReporEntrega()">Descargar Reporte de Entrega</button>
    </div>
  </div>
</ng-template>

<!-- MODAL REPORTE -->
<app-lfsa-modal [innTemplate]="enviarModalReport" [titulo]="'Seleccionar Tipo de Reporte'" [idButton]="'abrirModalReport'" [idOpen]="'ModalReport'"
  [idClose]="'cerrarModalReport'"></app-lfsa-modal>
<ng-template #enviarModalReport>
  <form [formGroup]="formularioReport" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]="" [control]="formularioReport.get('fechaIni')"
          [placeholder]="'Fecha Inicial'" formControlName="fechaIni" [label]="'Fecha Inicial'" [type]="'date'" [id]="'fechaIni'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]="" [control]="formularioReport.get('fechaFin')"
          [placeholder]="'Fecha Final'" formControlName="fechaFin" [label]="'Fecha Final'" [type]="'date'" [id]="'fechaFin'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-combo-box [mostrarImg]="false" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbTipoReport" 
          formControlName="tipo" [control]="formularioReport.get('tipo')" [claseLabel]="'letrasDanger'" [label]="'Seleccione Tipo*'" [id]="'tipo'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioReport.invalid"
            (click)="downloadReport()">Descargar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>